export class BadgeState {
  sentRequestStatuses;
}
